import { log } from 'console'

export const supportedSoftwareCarousel = (): void => {
  const supportedSoftware_2022Components = document.querySelectorAll('.js-supportedSoftware_2022') as unknown as HTMLElement[]

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!supportedSoftware_2022Components || !bodyElement) {
    return
  }

  supportedSoftware_2022Components.forEach(achivement => {
    const supportedSoftware_2022Wrapper = achivement.querySelector('.js-supportedSoftware_2022-wrapper') as unknown as HTMLElement
    const achievmentsInner = achivement.querySelector('.js-supportedSoftware_2022-inner') as unknown as HTMLElement

    const localStyleElement = achivement.querySelector('.js-style') as unknown as HTMLElement

    const localID = achivement.dataset.special_id

    const allLocalElems = achivement.querySelectorAll('.js-supportedSoftware_2022-single') as unknown as HTMLElement[]

    if (allLocalElems.length === 0) {
      return
    }

    let previousWidth = 0

    const checkCarouselSizing = () => {
      let localWidth = 0

      allLocalElems.forEach(icon => {
        const iconMarginLeft = parseInt(getComputedStyle(icon).marginLeft)
        const iconMarginRight = parseInt(getComputedStyle(icon).marginRight)

        localWidth += icon.offsetWidth + iconMarginLeft + iconMarginRight
      })

      if (window.innerWidth >= localWidth / 2) {
        achievmentsInner.classList.add('-maxSized')
      } else {
        achievmentsInner.classList.remove('-maxSized')
      }

      if (localWidth === previousWidth) {
        return
      }

      previousWidth = localWidth

      const supportedSoftware_2022Style = `
      @keyframes scroll-supportedSoftware_2022-${localID} {

        100% {
          transform: translateX(calc(-${(localWidth / 2)}px));
        }
      }
    `

      localStyleElement.innerHTML = supportedSoftware_2022Style

      supportedSoftware_2022Wrapper.style.width = `${localWidth / 2}px`
      achievmentsInner.style.width = `${localWidth}px`
      achievmentsInner.style.animation = `${localWidth / 2 / 100}s linear 0s infinite normal none running scroll-supportedSoftware_2022-${localID}`
    }

    // On resize
    window.addEventListener('resize', () => {
      checkCarouselSizing()
    })

    setInterval(() => {
      // checkCarouselSizing()
    }, 250)

    checkCarouselSizing()
  })
}
